import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './AdminDashboard.css';

const AdminDashboard = () => {
    const { t } = useTranslation();

    const getPerms = () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) return [];
            const payload = JSON.parse(atob(token.split('.')[1]));
            return payload.permissions || [];
        } catch (e) {
            return [];
        }
    };

    const userPerms = getPerms();

    const allCards = [
        { title: t('admin_users', 'Users'), description: t('admin_users_desc', 'Manage profiles, roles and permissions for users.'), link: '/admin/users', icon: '👥', perm: 'rbac.manage' },
        { title: t('admin_access', 'Access Control'), description: t('admin_access_desc', 'Manage Roles, Groups, Permissions and Routes in one place.'), link: '/admin/access-control', icon: '🛡️', perm: 'rbac.manage' },
    ];

    const cards = allCards.filter(card => !card.perm || userPerms.includes(card.perm) || userPerms.includes('admin'));

    return (
        <div className="admin-dashboard">
            <h2>{t('admin_dashboard', 'Admin Dashboard')}</h2>
            <div className="dashboard-grid">
                {cards.map((card, index) => (
                    <Link to={card.link} key={index} className="dashboard-card">
                        <div className="card-icon">{card.icon}</div>
                        <h3>{card.title}</h3>
                        <p>{card.description}</p>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default AdminDashboard;
